var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-header"},[_c('div',{staticClass:"site_head fc"},[_c('div',{staticClass:"fb"},[_c('span',[_vm._v("您好，欢迎来到"+_vm._s(_vm.siteData.name)+"官方网站！")]),_c('span',{staticClass:"fs"},[_c('img',{attrs:{"src":require("../../assets/images/bt01.png"),"alt":""}}),_vm._v(_vm._s(_vm.siteData.phone))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }